export default __webpack_public_path__ + "static/media/vertical-line2.eda22c7f.svg";